export const API_BASE = "https://api.lumanova.icu";

export const ICON_CONFIG = {
  favicon: `${API_BASE}/icon/title_icon.png`,
  siteTitle: "LumaNova AI",
  logo: `${API_BASE}/icon/main_icon.png`,
  botAvatarDark: `${API_BASE}/icon/chat_black.png`,
  botAvatarLight: `${API_BASE}/icon/chat_white.png`,
  userAvatar: null,
};
